import React, { useEffect } from "react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import robotoFont from "../../fonts/Roboto-Regular-base64";

const ExportButtons = ({ data }) => {

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Roboto-Regular.ttf", robotoFont); 
        this.addFont("Roboto-Regular.ttf", "Roboto", "normal");
      },
    ]);
  }, []);

  const exportPDF = () => {
    const doc = new jsPDF();
  
    doc.setFont("Roboto");
    doc.text("Lista Voluntari", 14, 15);
  
    autoTable(doc, {
      head: [[
        "Prenume", "Nume", "Telefon", "Email", "Oras", "Judet", "Tara"
      ]],
      body: data.map((v) => [
        v.prenume || "",
        v.nume || "",
        v.telefon || "",
        v.email || "",
        v.oras || "",
        v.judet || "",
        v.tara || "",
      ]),
      startY: 20,
      styles: { font: "Roboto", fontSize: 8 },
      headStyles: { fillColor: [1, 53, 141], textColor: 255 }, // albastru închis + text alb
    });
  
    doc.save("voluntari.pdf");
  };
  

  const exportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Voluntari");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(dataBlob, "voluntari.xlsx");
  };

  return (
    <div className="d-flex gap-3 mt-3 neumorphic p-3 rounded justify-content-center">
      <button className="btn btn-outline-primary" onClick={exportPDF}>
        Exportă PDF
      </button>
      <button className="btn btn-outline-success" onClick={exportExcel}>
        Exportă Excel
      </button>
    </div>
  );
};

export default ExportButtons;